<template>
  <div class="tag-container">
    <!-- Question Type -->
    <div
      v-if="isMultiChoice()"
      class="tag tag--white tooltip tag--large"
      data-tooltip="Multiple Choice"
    >
      <i class="fa fa-wrapper fa-list-ul" style="color: blue;"></i>
    </div>
    <div
      v-else-if="
        question.answer && !isMultiChoice() && question.answer.length > 0
      "
      class="tag tag--white tooltip tag--large"
      data-tooltip="Short Answer"
    >
      <i class="fa fa-wrapper fa-font" style="color: green;"></i>
    </div>
    <div v-else class="tag tag--white tag--large">
      <i class="fa fa-wrapper fa-ban" style="color: gray;"></i>
    </div>
    <!-- Other details -->
    <div
      v-if="question.is_in_exam"
      class="tag tag--white tooltip tag--large"
      data-tooltip="Published"
    >
      <i class="fa fa-wrapper fa-check-double" style="color: green;"></i>
    </div>
    <div
      v-if="question.is_mandatory"
      class="tag tag--white tooltip tag--large"
      data-tooltip="Mandatory question"
    >
      <i
        class="fa fa-wrapper fa-exclamation-circle"
        style="color: #dc4753;"
      ></i>
    </div>
    <inactive-icon v-bind:is_active="question.is_active"></inactive-icon>
    <div
      v-if="question.read_only"
      class="tag tag--white tooltip tag--large"
      data-tooltip="Read Only"
    >
      <i class="fa fa-wrapper fa-history" style="color: var(--cirrus-danger);">
      </i>
    </div>
  </div>
</template>
<style></style>
<script>
import InactiveIcon from "@/components/InactiveIcon";

export default {
  name: "question-status",
  components: {
    InactiveIcon,
  },
  props: {
    question: {}
  },
  methods: {
    isMultiChoice() {
      if (!this.question.is_multichoice) {
        for (let idx in [1, 2, 3, 4, 5]) {
          // Choices aren't defined until something is typed, so skip if DNE
          if (!this.question["choice_" + idx]) {
            continue;
          } else if (this.question["choice_" + idx].length > 0) {
            return true;
          }
        }
        // We get this far and nothing was true, so it's NOT a multichoice
        return false;
      } else {
        return this.question.is_multichoice;
      }
    }
  }
};
</script>
